import * as React from "react"
import {Skeleton} from "@mui/material";

import { useUserApp } from "@hooks";
import { TitleWithPopover, AppTableSeeker } from "@components";
import {isLoadingCommonFilters} from "@signals";
import {marketDetailsData} from "../@signals";
import { stockColumn, sellersColumn, discountColumn, retailerColumn, dispersionColumn, offersColumn } from "./columns"


export default function MarketplacesMarketDetails() {

	const { userUseRRSP } = useUserApp()
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={816} />
	if (!marketDetailsData.value.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Global Market Position Details" />}
		data={marketDetailsData.value}
		columns={[
			retailerColumn(),
			offersColumn(),
			sellersColumn(),
			discountColumn(),
			...userUseRRSP ? [dispersionColumn()] : [],
			stockColumn()
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [5, 10]
		}}
	/>

}